import { convertCo2Score } from '@/data/http/utils/convert-co2-score';
import { References } from '@/domain/impact-references/entities/references.entity';

type ReferencesDto = {
  sectors: {
    artists: {
      co2: { score: number };
    };
    team: {
      co2: { score: number };
    };
    public: {
      co2: { score: number };
    };
    site: {
      co2: { score: number };
    };
  };
};

export class ReferencesMapper {
  static dtoToEntity(dto: ReferencesDto): References {
    return {
      sectors: {
        artists: {
          co2: {
            score: convertCo2Score(dto.sectors.artists.co2.score),
          },
        },
        team: {
          co2: {
            score: convertCo2Score(dto.sectors.team.co2.score),
          },
        },
        public: {
          co2: {
            score: convertCo2Score(dto.sectors.public.co2.score),
          },
        },
        site: {
          co2: {
            score: convertCo2Score(dto.sectors.site.co2.score),
          },
        },
      },
    };
  }
}
